// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AccordionController from "./accordion_controller"
application.register("accordion", AccordionController)

import AutoTabController from "./auto_tab_controller"
application.register("auto-tab", AutoTabController)

import BasketController from "./basket_controller"
application.register("basket", BasketController)

import BootstrapCarouselController from "./bootstrap_carousel_controller"
application.register("bootstrap-carousel", BootstrapCarouselController)

import CarouselController from "./carousel_controller"
application.register("carousel", CarouselController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import CompositionController from "./composition_controller"
application.register("composition", CompositionController)

import CompositionRowController from "./composition_row_controller"
application.register("composition-row", CompositionRowController)

import CounterController from "./counter_controller"
application.register("counter", CounterController)

import CoverageMapController from "./coverage_map_controller"
application.register("coverage-map", CoverageMapController)

import DaterangePickerController from "./daterange_picker_controller"
application.register("daterange-picker", DaterangePickerController)

import DynamicAnchorController from "./dynamic_anchor_controller"
application.register("dynamic-anchor", DynamicAnchorController)

import EmailSuggestionController from "./email_suggestion_controller"
application.register("email-suggestion", EmailSuggestionController)

import FarmsMapController from "./farms_map_controller"
application.register("farms-map", FarmsMapController)

import FramePopoverController from "./frame_popover_controller"
application.register("frame-popover", FramePopoverController)

import FullscreenController from "./fullscreen_controller"
application.register("fullscreen", FullscreenController)

import MainController from "./main_controller"
application.register("main", MainController)

import MobileNavbarController from "./mobile_navbar_controller"
application.register("mobile-navbar", MobileNavbarController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import NoIframeController from "./no_iframe_controller"
application.register("no-iframe", NoIframeController)

import NotificationController from "./notification_controller"
application.register("notification", NotificationController)

import PasswordVisibilityController from "./password_visibility_controller"
application.register("password-visibility", PasswordVisibilityController)

import PaymentsController from "./payments_controller"
application.register("payments", PaymentsController)

import PopoverController from "./popover_controller"
application.register("popover", PopoverController)

import ProductsFilterController from "./products_filter_controller"
application.register("products-filter", ProductsFilterController)

import ScannerCratesController from "./scanner_crates_controller"
application.register("scanner-crates", ScannerCratesController)

import ScannerEntrustmentsController from "./scanner_entrustments_controller"
application.register("scanner-entrustments", ScannerEntrustmentsController)

import SlimSelectController from "./slim_select_controller"
application.register("slim-select", SlimSelectController)

import TelInputController from "./tel_input_controller"
application.register("tel-input", TelInputController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)

import ZoomController from "./zoom_controller"
application.register("zoom", ZoomController)
